import type { Importance, TileSize } from '../../../../types/infrastructure-map'

export const DEVICE_TYPE_ICONS: Record<string, string> = {
  workstation: '💻',
  'domain-controller': '🏛️',
  'file-server': '📁',
  'mail-server': '📧',
  'database-server': '🗄️',
  'proxy-server': '🔀',
  firewall: '🛡️',
  'network-switch': '🔌',
  router: '📡',
  server: '🖥️',
  laptop: '💻',
  mobile: '📱',
  unknown: '❓',
}

export const IMPORTANCE_BORDER_CLASSES: Record<Importance, string> = {
  low: 'border-emerald-500',
  medium: 'border-amber-500',
  high: 'border-orange-500',
  critical: 'border-red-500',
}

export interface TileSizeConfig {
  width: number
  height: number
  textClass: string
}

export const TILE_SIZE_CONFIG: Record<TileSize, TileSizeConfig> = {
  dot: { width: 16, height: 16, textClass: 'hidden' },
  small: { width: 100, height: 72, textClass: 'text-xs' },
  medium: { width: 140, height: 96, textClass: 'text-sm' },
  large: { width: 180, height: 120, textClass: 'text-base' },
}

export const COLLECTION_BADGE_PATH =
  'M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z'

export function iconSizeClass(tileSize: TileSize): string {
  if (tileSize === 'small') return 'text-lg'
  if (tileSize === 'medium') return 'text-xl'
  return 'text-2xl'
}
